module.exports = __webpack_public_path__ + "img/device-gray.74e2b457.png";